<template>
  <div class="svip">
    <div class="svip-title">{{svipData.title}}</div>
    <img :src="svipData.imageUrl" class="svip-img"/>
    <template v-if="svipData.payBackNumber===-1">
      <div class="one">
        <table width="100%">
          <tr v-for="(item,index) in repayLoanList" :key="index" :class="['one-item',{'mt10':svipData.breakBlock+1===index}]">
            <td width="50%" v-html="item[0]"></td>
            <td width="50%" v-html="item[1]"></td>
          </tr>
        </table>
      </div>
    </template>
    <template v-else>
      <div class="other">
        <table width="100%">
          <tr class="table-header">
            <th width="15%" class="yellow">期数</th>
            <th width="35%" class="yellow">每期应还（元）</th>
            <th width="15%" class="black">期数</th>
            <th width="35%" class="black">每期应还（元）</th>
          </tr>
          <tr v-for="(item,index) in repayLoanList" :key="index" class="other-item">
            <div class="grey">
              <td v-html="item[0]" :class="svipData.payBackNumber===index&&'red'"/>
              <td v-html="item[1]" :class="svipData.payBackNumber===index&&'red'"></td>
              <div class="hui-ben" v-if="svipData.payBackNumber===index"></div>
            </div>
            <td width="15%" v-html="item[2]"></td>
            <td width="35%" v-html="item[3]"></td>
          </tr>
        </table>
      </div>
    </template>
    <p class="svip-more">{{svipData.desc}}</p>
    <div class="svip-img">
      <div v-for="(item,index) in bannerList" :key="index" class="svip-img-item">
        <img :src="item.imageUrl" class="svip-img-item-img"/>
        <div class="svip-img-item-content">
          <p @click="jumpSvip">{{item.descList&&item.descList[0]}}</p>
          <p @click="jumpSvip">{{item.descList&&item.descList[1]}}</p>
        </div>
      </div>
    </div>
    <nd-button class="btn" @click="judgeOrder">{{svipData.buyButtonText}}</nd-button>
    <p @click="next" class="next">继续申请</p>
  </div>
</template>
<script>
import { getKey } from '@/assets/utils'
export default {
  watch: {
    svipDialog (value) {
      if (value) {
        this.$emit('close')
      }
    }
  },
  props: {
    svipData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    bannerList () {
      return this.svipData.bannerList || []
    },
    repayLoanList () {
      return this.svipData.repayLoanList || []
    }
  },
  data () {
    return {
    }
  },
  methods: {
    next () {
      this.$emit('next')
    },
    judgeOrder () {
      let str = ''
      if (this.svipData.payBackNumber === -1) {
        str = '1'
      } else {
        str = 'N'
      }
      this.$report({
        id: 10404,
        args: {
          status: str
        }
      })
      this.$emit('judgeOrder')
    },
    jumpSvip () {
      this.$report({
        id: 10504
      })
      const { couponSerialNos, couponType } = this.$route.query || {}
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      const channel = getKey('channel') || ''
      let data = `gid=${gid}&token=${token}&position=3&purchaseSVIP=fuli&channel=${channel}`
      couponSerialNos && (data += `&couponSerialNos=${couponSerialNos}`)
      couponType && (data += `&couponType=${couponType}`)
      window.location.replace(`${process.env.VUE_APP_PAYURL}/vip/ssvip?${data}&refurl=${window.location.origin}`)
    }
  }
}
</script>
<style scoped lang="less">
@import "../../../assets/less/mixin.less";

.mt10{
    margin-top:10px;
  }
  .red{
    color:#FF4633!important;
  }
.svip{
  width: 620px;
  background: linear-gradient(180deg, #FF4633 0%, #FFFFFF 100%);
  border-radius: 30px;
  padding:46px 30px 29px;
  &-title{
    // height: 67px;
    font-size: 48px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 67px;
    text-align: center;
  }
  &-img{
    width:560px;
    height:70px;
    margin:15px auto 0;
  }
  &-more{
    margin-top:40px;
    text-align: center;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 37px;
    position: relative;
  }
  &-more::before{
    position: absolute;
    content:'';
    display: block;
    width: 120px;
    height: 1px;
    background: #FF4633;
    top:20px;
  }
  &-more::after{
    position: absolute;
    content:'';
    display: block;
    width: 120px;
    height: 1px;
    background: #FF4633;
    top:20px;
    left:440px;
  }
  &-img{
    // margin:12px;
    display: flex;
    justify-content: space-between;
    &-item{
      width: 265px;
      height: 100px;
      background: #FFFFFF;
      border-radius: 10px;
      padding:18px 20px;
      display: flex;
      &-img{
        width:64px;
        height:64px;
      }
      &-content{
        margin-left:20px;
        display: flex;
        flex-direction: column;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 33px;
      }
    }
  }
  .btn{
    width: 440px;
    height: 80px;
    margin:60px auto 0;
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    border-radius: 40px;
  }
  .next{
    margin-top:30px;
    text-align:center;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF4633;
    line-height: 45px;
  }
}
.one{
  background: transparent !important;
  td:nth-child(1){
    background: #FFFBF2;
    color:#8C4A00;
  }
}
.other{
  .grey{
    width:50%;
    background: #FFFBF2;
    color:#8C4A00;
    position:relative;
    .hui-ben{
      position:absolute;
      top:0;
      left:200px;
      background:url('../image/img_huiben@2x.png');
      width:92px;
      height:68px;
      background-size:100% 100%;
    }
  }
}
.black{
    background: #eee;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #333333;
    height: 70px;
    display:flex;
    // align-items: center;
    flex-wrap: nowrap;
  }
  .yellow{
    background: #FDF1D6 !important;
    color: #8C4A00 !important;
    height: 70px !important;
    display:flex;
    // align-items: center;
    flex-wrap: nowrap;
  }
.one,.other{
    width: 560px;
    margin:10px auto 0;
    background: #FFFFFF;
    border-radius:20px;
    overflow: scroll;
    max-height:400px;
    tr{
      display: flex;
      background:white;
    }
    td,th{
      text-align: left;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 50px;
      overflow: hidden;
      padding:10px 10px 10px 20px;
      // text-overflow: ellipsis;
      //  white-space: nowrap;
    }
    &-item{
      font-size: 26px;
      display:flex;
      justify-content:space-between;
      align-items:center;
    }
  }
</style>